import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import MenuLayout from '../layouts/MenuLayout.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'dashboard' },
  },

  {
    name: '',
    path: '/',
    component: MenuLayout,
    children: [
      {
        name: 'dashboard',
        path: '',
        component: () => import('../pages/condor/Menu.vue'),
      },
    ],
  },

  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to:any, from:any, savedPosition:any) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

export default router
